import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnRecaptchaTemplateOptions } from './recaptcha-template-options';

export interface ISnRecaptchaFormFieldConfig extends FormlyFieldConfig {
  type: 'recaptcha';
  templateOptions: ISnRecaptchaTemplateOptions;
}
